import { createSlice } from '@reduxjs/toolkit';
import {
  addTokenReducer,
  getSessionValidReducer,
  getTokensReducer,
  loginReducer,
  logoutReducer,
} from './user.reducers';
import { UserState } from './user.types';

export const initialState: UserState = {
  loading: 'idle',
  authenticated: false,
  error: { name: '', message: '' },
  login: null,
  role: null,
  userData: null,
  authTokens: null,
  token: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    getTokensReducer(builder);
    addTokenReducer(builder);
    loginReducer(builder);
    getSessionValidReducer(builder);
    logoutReducer(builder);
  },
});

export default userSlice.reducer;
